<app-header></app-header>
<div class="content">
  <router-outlet></router-outlet>
</div>
<app-chat-widget></app-chat-widget>
